import moment from 'moment';
import { declOfNum } from 'utils/common';

export const accessDuration = (createdAt, expiresAt) => {
  const start = moment(
    createdAt
      ? moment(createdAt).format('YYYY-MM-DDTHH:mm:ss')
      : moment().format('YYYY-MM-DDTHH:mm:ss')
  );
  const fin = moment(moment(expiresAt).format('YYYY-MM-DDTHH:mm:ss'));

  const years = fin.diff(start, 'years');
  const months = fin.diff(start, 'months');
  const days = fin.diff(start, 'days');
  const hours = fin.diff(start, 'hours');
  const minutes = fin.diff(start, 'minutes');

  if (years > 0) {
    return `${years} ${declOfNum(years, ['Year', 'Years'])}`;
  } else if (months > 0) {
    return `${months} ${declOfNum(months, ['Month', 'Months'])}`;
  } else if (days > 0) {
    return `${days} ${declOfNum(days, ['Day', 'Days'])}`;
  } else if (hours > 0) {
    return `${hours} ${declOfNum(hours, ['hour', 'Hours'])}`;
  } else if (minutes > 0) {
    return `${minutes} ${declOfNum(minutes, ['Minute', 'Minutes'])}`;
  } else {
    return '0 Minutes';
  }
};
